export default "data:image/svg+xml,sh-ta.svg"